import { css, type Theme } from "@emotion/react";

export const meter = (theme: Theme) => css`
  width: 100%;
  display: flex;

  &&::-webkit-meter-optimum-value {
    background: ${theme.system.borderFocused};
  }

  // firefox
  &&::-moz-meter-bar {
    background: ${theme.system.borderFocused};
  }
`;

export const meterWrapper = css`
  padding: 0 2rem;
  height: 2.25rem;

  > :last-of-type {
    width: fit-content;
    height: 1.5rem;
  }
`;

export const centeredText = css`
  text-align: center;
`;

export const icon = css`
  height: 1.5rem;
  width: 1.5rem;
`;
